import jwtDecode from 'jwt-decode';
import DateUtils from '@/utils/date';

export default {
  // login(email, pass, cb) {
  //   cb = arguments[arguments.length - 1];
  //   if (localStorage.token) {
  //     if (cb) cb(true);
  //     this.onChange(true);
  //     return;
  //   }
  //   pretendRequest(email, pass, (res) => {
  //     if (res.authenticated) {
  //       localStorage.token = res.token;
  //       if (cb) cb(true);
  //       this.onChange(true);
  //     } else {
  //       if (cb) cb(false);
  //       this.onChange(false);
  //     }
  //   });
  // },
  checkTokenAlive() {
    const decodedToken = this.decodeToken(localStorage.token);
    if (!decodedToken || decodedToken.exp < DateUtils.unix()) {
      return false;
    }
    return true;
  },
  decodeToken(token) {
    if (token) return jwtDecode(token);
    return null;
  },

  getToken() {
    return localStorage.token;
  },

  getRole() {
//    console.log(jwtDecode(localStorage.token));
    return jwtDecode(localStorage.token).role;
  },

  logout(cb) {
    delete localStorage.token;
    if (cb) cb();
  },

  loggedIn() {
    return !!localStorage.token;
  },

  onChange() {},
};



// WEBPACK FOOTER //
// ./src/utils/auth.js